<div class="bug-bounty">
  <h2>برنامه باگ‌‌‌بانتی</h2>
  <p>
    سامانه های تحت پوشش تیم فنی ایپام با هدف شناسایی و رفع آسیب‌پذیری‌های احتمالی خود و ارائه هر چه بهتر خدمات در بستری امن، برنامه «باگ بانتی» را
    اجرا می‌کند. برای ارسال گزارش خود از طریق لینک <a href="mailto:Info@ipaam.ir">Info@ipaam.ir</a> اقدام فرمایید. شرایط و مقررات مربوط به شرح زیر
    است:
  </p>
  <h3>مقررات برنامه باگ‌بانتی</h3>
  <p>۱ـ گزارش آسیب‌پذیری‌ باید شامل کد اکسپلویت و یا سناریوی حمله مشخص باشد و گزارش‌های فاقد این اطلاعات ارزیابی نخواهد شد.</p>
  <p>
    ۲ـ بارگذاری مستندهای آسیب‌پذیری‌ها در سایت‌های اشتراکی، شبکه‌های اجتماعی و غیره، فقط با هماهنگی و تاییدیه کتبی سامانه های تحت پوشش تیم فنی ایپام
    امکان‌پذیر خواهد بود.
  </p>
  <p>
    ۳ـ دریافت پاداش به معنی مجوز جهت افشای گزارش نمی‌باشد و هرگونه افشای گزارش فقط با هماهنگی و تاییدیه کتبی سامانه های تحت پوشش تیم فنی ایپام
    امکان‌پذیر خواهد بود.
  </p>
  <p>۴ـ هیچ‌یک از موازین قانونی کشور نقض نشده باشد.</p>
  <p>
    ۵ـ به حریم شخصی افراد و کاربران احترام گذاشته شود و هیچگونه تعاملی با حساب کاربری افراد، بدون رضایت آن‌ها انجام ندهید. برای ارزیابی عملکرد
    آسیب‌پذیری‌های مربوط به حساب کاربری، باید از حساب کاربری شخصی خود استفاده کنید.
  </p>
  <p>۶ـ در هر گزارش فقط یک آسیب‌پذیری ارائه شود.</p>
  <p>۷ـ همه شواهد باید فقط در گزارش ارسالی گنجانده شود و هیچ بخشی از آن نباید در سرور دیگری بارگذاری شود.</p>
  <p>۸ـ از آدرسIP مشخصی برای بررسی و ارزیابی استفاده کنید و IP آدرس مذکور را در گزارش اعلام کنید.</p>
  <p>۹ـ شرح آسیب‌‌پذیری به صورت کامل به همراه شدت و خطرات احتمالی توضیح داده شود.</p>
  <p>۱۰ـ اطلاعات محرمانه نباید افشا شود و لازم است پس تایید گزارش از نگهداری آن‌ها اجتناب کنید.</p>
  <p>۱۱ـ تمام فعالیت‌ها و دسترسی‌ها می‌بایست در گزارش قید شود.</p>
  <p>۱۲ـ مراحل باز‌ تولید آسیب‌پذیری بطور کامل شرح داده شود.</p>
  <p>۱۳ـ مستندات لازم جهت دسترسی و استفاده از آسیب‌پذیری به همراه ابزارهای لازم به طور کامل بارگذاری شود.</p>
  <p>۱۴ـ لازم است هرگونه تنظیمات خاصِ مورد نیاز برای بازسازی حمله، ارائه شود.</p>
  <p>۱۵ـ به هیچ عنوان بهره‌برداری و سوءاستفاده از مشکلات امنیتی یافت شده، قابل قبول نبوده و قابل پیگیری می‌باشد.</p>
  <p>۱۶ـ به هیچ عنوان از اطلاعات افشاء شده در یک آسیب‌‌پذیری، برای نفوذ به سایر سیستم‌ها استفاده نشود.</p>
  <p>۱۷ـ از انجام عملیاتی و آزمونی، که اختلال در فرآیند‌ها و عملکرد سامانه‌های سامانه های تحت پوشش تیم فنی ایپام دارد اجتناب کنید.</p>
  <p>۱۸ـ لطفاً در ساعات شلوغ شبانه روز، از ابزارهای سنگین و روش‌هایی که ترافیک زیادی روی شبکه ایجاد می‌کنند، استفاده نکنید.</p>
  <p>۱۹ـ آسیب‌‌پذیری‌های گزارش شده می‌بایست تاثیر مشخصی بر کاربران، سامانه‌ها یا داده‌های مجموعه سامانه های تحت پوشش تیم فنی ایپام داشته باشد.</p>
  <p>۲۰ـ ثبت گزارش آسیب‌‌پذیری به معنای مطالعه و پذیرش قوانین می‌باشد.</p>
  <h3>قلمرو آزمون</h3>
  <p>اپلیکیشن موبایل Android و iOS سامانه های تحت پوشش تیم فنی ایپام + کلیه وب‌سرویس‌های پشتی</p>
  <h3>شرایط پرداختی</h3>
  <p>
    پس از اعلام آسیب‌‌پذیری، آسیب‌‌پذیری توسط تیم فنی ایپام ارزیابی شده و پس از انجام مراحل ابتدایی برای رفع آسیب‌پذیری، مبلغ جایزه پرداخت خواهد شد.
  </p>
  <p>لازم به ذکر است که منظور از اعلام آسیب‌‌پذیری یعنی گزارش ارسالی کامل و بدون هیچ کاستی باشد.</p>
  <p>امتیاز و مبلغ نهایی بر اساس شدت تاثیرگذاری و بر اساس CVSS3 محاسبه خواهد شد.</p>
  <p>حداقل پرداخت به ازای گزارش‌های آسیب‌‌پذیری شامل پاداش، صفر تومان می‌باشد.</p>
  <p>
    &nbsp;حداکثر پرداخت به ازای گزارش‌های آسیب‌‌پذیری شامل پاداش، مبلغ
    <span style="text-decoration: line-through"> ۵۰۰,۰۰۰,۰۰۰ ریال (معادل پنجاه میلیون تومان)&nbsp; </span>
    <span style="color: red; font-weight: bolder"> 1,000,000,000 ریال (معادل صد میلیون تومان) </span>
    <br />
    <br />
  </p>

  <ul class="list">
    <li>
      برای آسیب‌‌پذیری سطح حیاتی تا
      <span style="text-decoration: line-through"> ۵۰ میلیون تومان&nbsp; </span>
      <span style="color: red; font-weight: bolder"> ۷۰ تا ۱۰۰ میلیون تومان</span>
    </li>
    <li>برای آسیب‌‌پذیری سطح خطرناک ۱۰ تا ۲۰ میلیون تومان</li>
    <li>برای آسیب‌‌پذیری سطح متوسط ۱ تا ۵ میلیون تومان</li>
    <li>برای آسیب‌‌پذیری سطح پایین 0</li>
  </ul>
  <h3>آسیب‌‌پذیری‌های غیرقابل قبول</h3>
  <ul class="list">
    <li>هر نوع گزارش بدون داشتن اکسپلویت و سناریو.</li>
    <li>آسیب‌‌پذیری‌های MITM.</li>
    <li>آسیب‌‌پذیری‌هایی که قبلاً توسط سایر متخصصین گزارش شده باشد.</li>
    <li>آسیب‌‌پذیری‌هایی که از نظر Root Cause (ریشه یکسان) با باگ‌های گزارش شده باگ‌بانتی قبلی یکسان باشند.</li>
    <li>آسیب‌‌پذیری‌هایی که به ۳ مرحله یا بیشتر نیاز به تعامل با کاربر داشته باشند.</li>
    <li>صفحات ادمین قابل دسترس بدون نفوذ.</li>
    <li>حملات مهندسی اجتماعی و Phishing.</li>
    <li>حملات از كاراندازی سرویس (DoS/DDoS).</li>
    <li>آسیب‌پذیری‌هایی که در دامنه‌ها و آدرس‌های IP غیر از محدوده‌ مجاز هدف باشد.</li>
    <li>گزارش‌های ارائه شده توسط اسکنر‌ها و سایر ابزار‌های اتوماتیک، بدون ارائه اکسپلویت.</li>
    <li>آسیب‌پذیری‌های مربوط به نشت اطلاعات سرور و پیکربندی نادرست آن، مانند نسخه و نوع وب سرور.</li>
    <li>آسیب‌پذیری‌های مربوط به SSL و Best Practiceهای مربوط به آن.</li>
    <li>آسیب‌پذیری‌های مربوط به مرورگرهای قدیمی.</li>
    <li>آسیب‌پذیری‌های مربوط به حملات فیزیکی.</li>
    <li>آسیب‌پذیری‌های Content Spoofing.</li>
    <li>آسیب‌‌پذیری SSRF بدون اکسپلویت و یا با داشتن صرفا DNS Query.</li>
    <li>آسیب‌پذیری‌های Clickjacking در صورتی که در صفحات حساس نباشد.</li>
    <li>آسیب‌پذیری‌های self*.</li>
    <li>
      حملات Brute Force به غیر از موارد مربوط به Captcha، شناسایی کدهای OTP، پارامترهایی که بر اساس الگو (pattern) مانند datetime , id می‌باشند.
    </li>
    <li>تمامی آسیب‌پذیری‌های مربوط به وردپرس.</li>
    <li>موارد مربوط به رکوردهای DNS مرتبط با Email و نامه‌نگاری الکترونیکی جعلی (E-mail spoofing).</li>
    <li>گزارش پایین بودن ورژن کتابخانه‌ها و نرم‌افزار‌های به‌کار برده شده.</li>
    <li>بررسی هدرها و header injection و پروتکل http و پارامتر‌های آن.</li>
    <li>موارد Option Index اگر به داده حساس نرسد.</li>
    <li>تمامی موارد مرتبط با به دست آوردن نام‌های کاربری با استفاده از (account/e-mail/phone enumeration).</li>
    <li>آسیب‌پذیری‌های CSRF مربوط به logout.</li>
    <li>تمامی آسیب‌پذیری‌های مربوط به Email validation not enforced.</li>
    <li>تمامی آسیب‌پذیری‌های مربوط به Cookie valid after password change/reset یا session fixation.</li>
    <li>تمامی آسیب‌پذیری‌های مربوط به Domain authentication.</li>
    <li>آسیب‌پذیری CORS misconfiguration بدون اکسپلویت.</li>
    <li>پیداکردن IPهای پشت CDN بدون داشتن سناریو و اکسپلویت برای حمله‌ای تاثیرگذار یا اینکه در بخش قابل قبول نیامده باشد.</li>
    <li>آسیب‌پذیری Information Disclosure بدون داشتن سناریویی برای بهره‌برداری و اکسپلویت.</li>
    <li>آسیب‌پذیری Crossdomain.xml.</li>
    <li>آسیب‌پذیری تزریق csv.</li>
    <li>آسیب‌پذیری‌هایی که تاثیر آن، تنها بر سمت دستگاه کاربر (Client) باشد. (نرم‌افزار اندروید)</li>
    <li>آسیب‌پذیری‌هایی که مهندسی معکوس، دیکامپایل و موارد مشابه باشد. (نرم‌افزار اندروید)</li>
    <li>
      آسیب‌پذیری‌هایی که نیاز به دسترسی فیزیکی به دستگاه‌های اندرویدی دارد و یا آسیب‌پذیری که خطری کاربران را تهدید نمی‌کند. (نرم‌افزار اندروید)
    </li>
    <li>
      سناریوهایی که پس از انجام فرآیند سیستمی به صورت انسانی عملیاتی انجام می‌شود که همراه با بررسی داده‌ها است. (توسط ادمین، مدیر کمپین، واحد مالی و
      غیره)
    </li>
  </ul>
</div>
